<template>
  <v-form
    v-if="showForm"
    ref="form"
    name="search-appointment"
  >
    <v-text-field
      v-model="id"
      name="appointment-id"
      type="number"
      label="案件番号"
      hint="案件番号を入れるとすぐ検査ページにリダイレクトされます"
    />
    <v-text-field
      v-model="fields.phone"
      name="personal-mobile"
      type="number"
      label="電話番号"
    />
    <v-text-field
      v-model="fields.fio"
      name="fio"
      type="text"
      label="氏名"
    />
    <cp-date-picker
      v-model="fields.dateFrom"
      label="訪問日から"
      close-on-change
    />
    <cp-date-picker
      v-model="fields.dateTo"
      label="訪問日まで"
      close-on-change
    />
    <cp-radio
      v-model="fields.inspectionType"
      :items="inspectionTypes"
      hint="検査タイプ"
    />
    <v-layout class="mt-3">
      <v-flex
        md8
        offset-md2
      >
        <v-btn
          :loading="loading"
          color="primary"
          type="submit"
          block
          large
          @click.prevent="submit"
        >検索</v-btn>
      </v-flex>
    </v-layout>
  </v-form>
  <v-layout
    v-else
    class="mt-3"
  >
    <v-flex
      md8
      offset-md2
    >
      <v-btn
        :loading="loading"
        color="primary"
        type="submit"
        block
        large
        outline
        @click.prevent="showForm = true"
      >検索し直す</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { SEARCH_APPOINTMENTS, GET_CAR_ID_AND_STEP_INFO } from '../../queries';
import { inspectionTypes, stepById } from '../../options';
import { isCancelInspection, getServerTime } from '../../cancelInspection';

const APPOINTMENT_STATUS_INSPECTION_CONFIRMED = '255';
const APPOINTMENT_STATUS_INSPECTION = '256';
const APPOINTMENT_SUBSTATUS_INSPECTION_STARTED = '201';
const APPOINTMENT_SUBSTATUS_INSPECTION_FINISHED = '202';
const APPOINTMENT_STATUS_SELF_INSPECTION_CONFIRMED = '742';
const substatuses = [
  APPOINTMENT_SUBSTATUS_INSPECTION_STARTED,
  APPOINTMENT_SUBSTATUS_INSPECTION_FINISHED,
];

export default {
  props: {
    phone: {
      type: String,
      default: null,
    },
    fio: {
      type: String,
      default: null,
    },
    dateFrom: {
      type: String,
      default: null,
    },
    dateTo: {
      type: String,
      default: null,
    },
    inspectionType: {
      type: String,
      default: null,
    },
  },
  apollo: {
    customers: {
      pollInterval: 3000,
      fetchPolicy: 'network-only',
      query: SEARCH_APPOINTMENTS,
      variables() {
        const customFilters = [
          { field: 'a.id', operator: 'GT', value: '1400000' },
        ];

        if (this.dateFrom) {
          customFilters.push({ field: 'a.time', operator: 'GE', value: `${this.dateFrom} 00:00:00` });
        } else {
          customFilters.push({ field: 'a.time', operator: 'GE', value: '2018-01-01' });
        }

        if (this.dateTo) {
          customFilters.push({ field: 'a.time', operator: 'LE', value: `${this.dateTo} 23:59:59` });
        }

        if (this.inspectionType) {
          customFilters.push({ field: 'a.self_inspection_flag', operator: 'EQ', value: `${this.inspectionType}` });
        }

        const filters = {};
        if (this.phone) {
          filters.phone = this.phone;
        }

        if (this.fio) {
          customFilters.push({
            field: 'CONCAT(COALESCE(c.last_name, ""), COALESCE(c.name, ""))',
            operator: 'LIKE',
            value: this.fio,
          });
        }

        return {
          filters: {
            ...filters,
            customFilters,
          },
        };
      },
      async result({ data }) {
        this.loading = false;
        this.showForm = !data.customers.data.length;
        const serverTime = await getServerTime(this.$apollo);

        const filtered = (data.customers.data || []).filter((a) => {
          const { status, substatus, dateCreate } = a.appointment;

          return [
            APPOINTMENT_STATUS_INSPECTION_CONFIRMED,
            APPOINTMENT_STATUS_SELF_INSPECTION_CONFIRMED,
          ].includes(status)
          || (status === APPOINTMENT_STATUS_INSPECTION && substatuses.includes(substatus))
          || isCancelInspection(status, dateCreate, serverTime);
        });
        this.$emit('loaded', filtered, serverTime);
      },
    },
  },
  data() {
    return {
      inspectionTypes,
      loading: false,
      showForm: true,
      id: null,
      fields: {
        phone: this.phone,
        fio: this.fio,
        date: this.date,
        inspectionType: this.inspectionType,
      },
    };
  },
  computed: {
    filteredParams() {
      const params = {
        ...this.fields,
      };

      Object.keys(params)
        .forEach(key => (params[key] === null || params[key] === '')
          && delete params[key]);

      return params;
    },
    requestParams() {
      return {
        ...this.filteredParams,
        date: this.filteredParams.date && new Date(this.filteredParams.date).getTime() / 1000,
      };
    },
  },
  watch: {
    async id(newVal) {
      if ((newVal.length >= 7) && (await this.canGoToNext(newVal))) {
        this.$router.push(`/inspection/${newVal}`);
      }
    },
  },
  mounted() {
    if (Object.keys(this.filteredParams).length > 0 || this.$route.query.submit) {
      this.showForm = false;
      this.submit();
      delete this.$route.query.submit;
    }
  },
  methods: {
    async canGoToNext(id) {
      if (!id) return false;
      const { data } = await this.$apollo.query({
        query: GET_CAR_ID_AND_STEP_INFO,
        variables: { id: parseInt(id, 10) },
      });
      const { selfInspectionFlag, clientCabinetWorkflow } = data.appointment;

      if (!parseInt(selfInspectionFlag, 10)) return true;

      const selfCompStep = stepById('SelfInspection.Complete');
      const currentStep = stepById(clientCabinetWorkflow.step);
      return !!((currentStep && currentStep.order >= selfCompStep.order));
    },
    submit() {
      this.$router.push({ path: '/search/', query: this.filteredParams });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forms/SearchForm.vue